export const projects = [
  {
    title: 'Personal Portfolio Website',
    description: 'A website showcasing my skills and experience.',
    link: 'https://your-portfolio-website.com', // Replace with your website link
    imageUrl: 'rothko.png', // Replace with your image URL
    technologies: ['React', 'JavaScript', 'HTML', 'CSS'],
    accomplishments: ['Clean and responsive design', 'Interactive elements'],
    category: 'Web Development',
    date: new Date('2024-05-14'), // Updated date
  },
  {
    title: 'Mental Health Chatbot',
    description: 'A chatbot designed to provide support and resources for mental health.',
    link: 'https://your-mental-health-chatbot.com', // Replace with your website link (if applicable)
    imageUrl: 'basquiat.png', // Replace with an image related to mental health (optional)
    technologies: ['Natural Language Processing', 'Dialogflow', 'Machine Learning (optional)'], // Technologies used for chatbots
    accomplishments: ['Provides mental health resources and support', 'Conversational interface for user interaction'],
    category: 'Artificial Intelligence', // New category for chatbot
    date: new Date('2024-05-21'), // Updated date
  },
  {
    title: 'Working at Chipotle',
    description: 'Gained valuable experience in fast-paced teamwork and customer service.',
    link: 'https://www.chipotle.com/', // Link to Chipotle website
    imageUrl: 'ecommerce-platform.png', // Replace with an image related to Chipotle (optional)
    technologies: ['Communication', 'Teamwork', 'Customer Service'], // No specific technologies used, so focus on skills
    accomplishments: ['Developed strong communication and interpersonal skills', 'Provided excellent customer service in a high-pressure environment'],
    category: 'Work Experience', // New category for non-tech projects
    date: new Date('2024-5-01'), // Update with your start date at Chipotle
  },
  {
    title: 'Becoming an Influencer & Inspirational Videos',
    description: 'A project focused on building an online presence and creating inspirational content.',
    link: 'https://your-influencer-profile.com', // Replace with your influencer profile link (if applicable)
    imageUrl: 'corgi.png', // Replace with an image related to influencers (optional)
    technologies: ['Social Media Marketing', 'Video Editing', 'Content Creation'], // Technologies used for influencer marketing
    accomplishments: ['Grew a social media following', 'Created engaging and inspirational video content'],
    category: 'Content Creation', // New category for influencer project
    date: new Date('2024-04-24'), // Updated date
  },
];
